import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';

const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="footer" className="bg-[#3D2020] text-white/80 py-16">
      <div className="px-5 md:px-10 lg:px-14 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-rh.png" alt="Red House" className="h-8 w-8 rounded-full" />
              <span className="font-heading font-bold text-[#E92A3E] text-lg">Red House Residency</span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed">
              {t('footer.desc')}
            </p>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4">{t('footer.contact')}</h3>
            <div className="space-y-3 text-sm">
              <a href="mailto:studio@redhouse.co" className="flex items-center gap-3 text-white/60 hover:text-white transition-colors">
                <Mail size={15} /> studio@redhouse.co
              </a>
              <div className="flex items-center gap-3 text-white/60">
                <Phone size={15} /> <span>Booking: 06 51 92 36 17</span>
              </div>
              <div className="flex items-center gap-3 text-white/60">
                <Phone size={15} /> <span>Studio: 09 53 26 45 75</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4">{t('footer.address')}</h3>
            <div className="flex items-start gap-3 text-sm text-white/60">
              <MapPin size={15} className="mt-0.5 flex-shrink-0" />
              <div>
                <p>5 rue Casimir Boirot</p>
                <p>51120 La Forestière</p>
                <p>Champagne, France</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-xs text-white/30">
          <p>&copy; {new Date().getFullYear()} Red House Residency</p>
          <span className="hidden sm:inline">·</span>
          <Link to="/mentions-legales" className="hover:text-white/60 transition-colors" data-testid="footer-legal-link">
            {t('footer.legal')}
          </Link>
          <span className="hidden sm:inline">·</span>
          <Link to="/politique-de-confidentialite" className="hover:text-white/60 transition-colors" data-testid="footer-privacy-link">
            {t('footer.privacy')}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
